module.exports = __webpack_public_path__ + "static/media/cover-serverless-grid.f384b516.png";